import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const sundayPollApi = createAsyncThunk(
    'auth/sunday-polls',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.sundayPollsAction(`poll-list`,0), { params: data })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const sundayPollSlice = createSlice({
    name: 'sunday-polls',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(sundayPollApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(sundayPollApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.total = action?.payload?.count;
            state.message = action?.payload?.message
        })
        builder.addCase(sundayPollApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const sundayPollReducer = sundayPollSlice.reducer